module.exports = __webpack_public_path__ + "img/sri-lanka.8b6bf6d7.svg";